import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { HttpClient } from '@angular/common/http';
import { ErrorService } from '../error/error.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { map, share } from 'rxjs/operators';
import { Any } from 'json2typescript';

@Injectable({
  providedIn: 'root'
})
export class ApiService extends ApiBaseService {

  baseUrl = environment.backend_host + '/api';

  constructor(
    public http: HttpClient,
    protected errorService: ErrorService,
    protected spinner: NgxSpinnerService) {
    super(spinner, errorService);
  }

  // calendar

  public fetchHolidays = (): Observable<Any> =>
    this.http.get<any>('https://holidayapi.com/v1/holidays', {
      params: {
        country: 'EG',
        year: String(new Date().getFullYear() - 1),
        key: '108ba780-fc7c-47d9-b2e5-544173dad32b',
      },
    }).pipe(share());
}
